import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { useNavigate } from 'react-router-dom'
import Link from '@mui/material/Link'
import NotificationsHeader from './NotificationsHeader'
import NotificationItem from './NotificationItem'
import NotificationsFooter from './NotificationsFooter'
import { useNotifications, useMarkNotificationAsRead, useMarkAllNotificationsAsRead } from 'services/api/notification/notificationHooks'

const resolveNotificationRoute = (item) => {
  const detailData = item?.detailData || {}
  const type = item?.type

  if (type === 'Task') {
    return `/app/tasks-dashboard/my-tasks`
  }

  if (type === 'Leave') {
    return `/app/approval-center/leave/pending`
  }

  if (type === 'Claim') {
    return `/app/approval-center/claim/pending`
  }

  if (type === 'Payroll') {
    return `/app/payroll/dashboard`
  }

  // if (type === 'Appraisal') {
  //   return `/app/tasks-dashboard/project-tracker` //KIV
  // }

  if (type === 'Attendance') {
    return `/app/attendance`
  }

  return '/app/notifications'
}

const NotificationsPopover = ({ anchorEl, open, onClose }) => {
  const navigate = useNavigate()

  const { data, isLoading } = useNotifications({
    page: 1,
    perPage: 20,
    enabled: open,
  })

  const markOneReadMutation = useMarkNotificationAsRead()
  const markAllReadMutation = useMarkAllNotificationsAsRead()

  const notifications = data?.items || []
  const unreadNotifications = notifications.filter((n) => n.isUnread)
  const unreadCount = unreadNotifications.length

  const handleNotificationClick = (item) => {
    const targetRoute = resolveNotificationRoute(item)

    if (item.isUnread) {
      markOneReadMutation.mutate(item.id, {
        onSuccess: () => {
          onClose?.()
          navigate(targetRoute)
        },
      })
      return
    }

    onClose?.()
    navigate(targetRoute)
  }

  const handleMarkAllReadClick = () => {
    if (unreadCount === 0 || markAllReadMutation.isLoading) return
    markAllReadMutation.mutate()
  }

  const handleViewAllClick = () => {
    onClose?.()
    navigate('/app/notifications')
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          mt: 1.5,
          minWidth: 380,
          maxWidth: 420,
          maxHeight: '80vh',
          borderRadius: 2,
          boxShadow: 3,
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Box sx={{ pb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
          <NotificationsHeader unreadCount={unreadCount} />

          {unreadCount > 0 && (
            <Link
              component="button"
              type="button"
              onClick={handleMarkAllReadClick}
              underline="hover"
              sx={{
                color: '#2666BE',
                fontWeight: 400,
                fontSize: '0.875rem',
                whiteSpace: 'nowrap',
                opacity: markAllReadMutation.isLoading ? 0.6 : 1,
                pointerEvents: markAllReadMutation.isLoading ? 'none' : 'auto',
              }}
            >
              {markAllReadMutation.isLoading ? 'Marking...' : 'Mark all as read'}
            </Link>
          )}
        </Box>

        {isLoading ? (
          <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={24} />
          </Box>
        ) : unreadNotifications.length === 0 ? (
          <Box sx={{ py: 2 }}>
            <Typography variant="body2" color="text.secondary">
              No unread notification.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {unreadNotifications.map((item) => (
              <NotificationItem
                key={item.id}
                type={item.type}
                description={item.description}
                timeAgo={item.timeAgo}
                isUnread={item.isUnread}
                onClick={() => handleNotificationClick(item)}
              />
            ))}
          </Box>
        )}

        <NotificationsFooter onClick={handleViewAllClick} />
      </Box>
    </Menu>
  )
}

export default NotificationsPopover
